(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(30441);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _BlueButton_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93589);
/* harmony import */ var _BlueButton_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_BlueButton_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var BlueButton = function(param) {
    var onClick = param.onClick, style = param.style, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: onClick,
        className: "".concat((_BlueButton_module_scss__WEBPACK_IMPORTED_MODULE_2___default().BlueButton), " ").concat(style),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlueButton);


/***/ }),

/***/ 68737:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _contexts_ModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86662);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75971);
/* harmony import */ var _utils_constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23531);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _BtnConnectWallet_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29870);
/* harmony import */ var _BtnConnectWallet_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_BtnConnectWallet_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _GreenButton_GreenButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53743);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_2__]);
smart_db__WEBPACK_IMPORTED_MODULE_2__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];







var BtnConnectWallet = function() {
    var walletStore = (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .useWalletActions */ .Za7)().walletStore;
    var openModal = (0,_contexts_ModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)().openModal;
    var handleClick = function() {
        openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_3__/* .ModalsEnums.WALLET_CONNECT */ .DC.WALLET_CONNECT);
    };
    var svgWallet = walletStore.isConnected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 24 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "SVGRepo_bgCarrier",
                strokeWidth: "0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "SVGRepo_tracerCarrier",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "SVGRepo_iconCarrier",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.1009 8.00353C21.0442 7.99996 20.9825 7.99998 20.9186 8L20.9026 8.00001H18.3941C16.3264 8.00001 14.5572 9.62757 14.5572 11.75C14.5572 13.8724 16.3264 15.5 18.3941 15.5H20.9026L20.9186 15.5C20.9825 15.5 21.0442 15.5001 21.1009 15.4965C21.9408 15.4434 22.6835 14.7862 22.746 13.8682C22.7501 13.808 22.75 13.7431 22.75 13.683L22.75 13.6667V9.83334L22.75 9.81702C22.75 9.75688 22.7501 9.69199 22.746 9.6318C22.6835 8.71381 21.9408 8.05657 21.1009 8.00353ZM18.1717 12.75C18.704 12.75 19.1355 12.3023 19.1355 11.75C19.1355 11.1977 18.704 10.75 18.1717 10.75C17.6394 10.75 17.2078 11.1977 17.2078 11.75C17.2078 12.3023 17.6394 12.75 18.1717 12.75Z",
                        fill: "#FFFFFF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.9179 17C21.067 16.9961 21.1799 17.1342 21.1394 17.2778C20.9387 17.9902 20.62 18.5975 20.1088 19.1088C19.3604 19.8571 18.4114 20.1892 17.239 20.3469C16.0998 20.5 14.6442 20.5 12.8064 20.5H10.6936C8.85583 20.5 7.40019 20.5 6.26098 20.3469C5.08856 20.1892 4.13961 19.8571 3.39124 19.1088C2.64288 18.3604 2.31076 17.4114 2.15314 16.239C1.99997 15.0998 1.99998 13.6442 2 11.8064V11.6936C1.99998 9.85583 1.99997 8.40019 2.15314 7.26098C2.31076 6.08856 2.64288 5.13961 3.39124 4.39124C4.13961 3.64288 5.08856 3.31076 6.26098 3.15314C7.40019 2.99997 8.85582 2.99998 10.6936 3L12.8064 3C14.6442 2.99998 16.0998 2.99997 17.239 3.15314C18.4114 3.31076 19.3604 3.64288 20.1088 4.39124C20.62 4.90252 20.9386 5.50974 21.1394 6.22218C21.1799 6.36575 21.067 6.50387 20.9179 6.5L18.394 6.50001C15.5574 6.50001 13.0571 8.74091 13.0571 11.75C13.0571 14.7591 15.5574 17 18.394 17L20.9179 17ZM5.75 7C5.33579 7 5 7.33579 5 7.75C5 8.16421 5.33579 8.5 5.75 8.5H9.75C10.1642 8.5 10.5 8.16421 10.5 7.75C10.5 7.33579 10.1642 7 9.75 7H5.75Z",
                        fill: "#FFFFFF"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 24 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "SVGRepo_bgCarrier",
                strokeWidth: "0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "SVGRepo_tracerCarrier",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "SVGRepo_iconCarrier",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M6 8H10",
                        stroke: "#FFFFFF",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M20.8333 9H18.2308C16.4465 9 15 10.3431 15 12C15 13.6569 16.4465 15 18.2308 15H20.8333C20.9167 15 20.9583 15 20.9935 14.9979C21.5328 14.965 21.9623 14.5662 21.9977 14.0654C22 14.0327 22 13.994 22 13.9167V10.0833C22 10.006 22 9.96726 21.9977 9.9346C21.9623 9.43384 21.5328 9.03496 20.9935 9.00214C20.9583 9 20.9167 9 20.8333 9Z",
                        stroke: "#FFFFFF",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M20.965 9C20.8873 7.1277 20.6366 5.97975 19.8284 5.17157C18.6569 4 16.7712 4 13 4L10 4C6.22876 4 4.34315 4 3.17157 5.17157C2 6.34315 2 8.22876 2 12C2 15.7712 2 17.6569 3.17157 18.8284C4.34315 20 6.22876 20 10 20H13C16.7712 20 18.6569 20 19.8284 18.8284C20.6366 18.0203 20.8873 16.8723 20.965 15",
                        stroke: "#FFFFFF",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M17.9912 12H18.0002",
                        stroke: "#FFFFFF",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GreenButton_GreenButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        onClick: handleClick,
        style: (_BtnConnectWallet_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btnConnectWallet),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: svgWallet
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BtnConnectWallet);

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 53743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var GreenButton = function(param) {
    var onClick = param.onClick, style = param.style, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: onClick,
        className: style,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GreenButton);


/***/ }),

/***/ 38347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Otc; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Otc_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97565);
/* harmony import */ var _Otc_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Otc_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _OtcCard_OtcCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72226);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55208);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_OtcCard_OtcCard__WEBPACK_IMPORTED_MODULE_1__, _utils_utils__WEBPACK_IMPORTED_MODULE_2__]);
([_OtcCard_OtcCard__WEBPACK_IMPORTED_MODULE_1__, _utils_utils__WEBPACK_IMPORTED_MODULE_2__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
// Otc.tsx





function Otc(param) {
    var seccionCaption = param.seccionCaption, tokens = param.tokens;
    var otcElems = tokens.map(function(tokenInterface) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OtcCard_OtcCard__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .tokenMetadataToOtcCard */ .q)(tokenInterface)), tokenInterface.token.TN_Hex + tokenInterface.token.CS);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_Otc_module_scss__WEBPACK_IMPORTED_MODULE_4___default().OtcContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Otc_module_scss__WEBPACK_IMPORTED_MODULE_4___default().seccionCaption),
                children: [
                    " ",
                    seccionCaption
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Otc_module_scss__WEBPACK_IMPORTED_MODULE_4___default().separator),
                children: " "
            }),
            otcElems
        ]
    });
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 72226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OtcCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _OtcCard_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38132);
/* harmony import */ var _OtcCard_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_OtcCard_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75971);
/* harmony import */ var _utils_constants_images__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24072);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_2__]);
smart_db__WEBPACK_IMPORTED_MODULE_2__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
// OtcCard.tsx





function OtcCard(param) {
    var image = param.image, photoAlt = param.photoAlt, tokenName = param.tokenName, tokenAmount = param.tokenAmount, btnMod = param.btnMod;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_OtcCard_module_scss__WEBPACK_IMPORTED_MODULE_3___default().otcCardContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_OtcCard_module_scss__WEBPACK_IMPORTED_MODULE_3___default().otcBox),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_OtcCard_module_scss__WEBPACK_IMPORTED_MODULE_3___default().otcDescription),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                className: (_OtcCard_module_scss__WEBPACK_IMPORTED_MODULE_3___default().otcTokenPhoto),
                                src: image !== "" ? (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .getUrlForImage */ ._rQ)(image) : _utils_constants_images__WEBPACK_IMPORTED_MODULE_4__/* .GENERIC */ .tJ,
                                alt: photoAlt,
                                width: 65,
                                height: 65,
                                unoptimized: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_OtcCard_module_scss__WEBPACK_IMPORTED_MODULE_3___default().otcTokenName),
                                children: [
                                    " ",
                                    tokenName,
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: (_OtcCard_module_scss__WEBPACK_IMPORTED_MODULE_3___default().tokenAmount),
                        children: [
                            " ",
                            tokenAmount.toString(),
                            " Tokens "
                        ]
                    }),
                    btnMod
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_OtcCard_module_scss__WEBPACK_IMPORTED_MODULE_3___default().separator),
                children: " "
            })
        ]
    });
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 75610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TokenCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _useTokenCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29182);
/* harmony import */ var _TokenCard_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3714);
/* harmony import */ var _TokenCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_TokenCard_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Buttons_BlueButton_BlueButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69522);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75971);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_constants_images__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24072);
/* harmony import */ var _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16573);
/* harmony import */ var _LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78470);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_3__, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__]);
([smart_db__WEBPACK_IMPORTED_MODULE_3__, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
// TokenCard.tsx











function TokenCard(prop) {
    var ref = (0,_useTokenCard__WEBPACK_IMPORTED_MODULE_1__/* .useTokenCard */ .Y)(), handleInputChange = ref.handleInputChange, amount = ref.amount, imageSize = ref.imageSize;
    var appStore = (0,smart_db__WEBPACK_IMPORTED_MODULE_3__/* .useAppStore */ .qrW)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_TokenCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tokenCardContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                className: (_TokenCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tokenPhoto),
                src: prop.token.image !== undefined ? (0,smart_db__WEBPACK_IMPORTED_MODULE_3__/* .getUrlForImage */ ._rQ)(prop.token.image) : _utils_constants_images__WEBPACK_IMPORTED_MODULE_8__/* .GENERIC */ .tJ,
                alt: prop.token.TN_Hex,
                width: imageSize,
                height: imageSize,
                unoptimized: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_TokenCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tokenName),
                children: (0,smart_db__WEBPACK_IMPORTED_MODULE_3__/* .hexToStr */ .NdO)(prop.token.TN_Hex)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_TokenCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tokenAmount),
                children: prop.token.amount.toString()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_TokenCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().separator)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_TokenCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tokenAmountForm),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_TokenCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tokenAmountCaption),
                        children: "Amount:"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        className: (_TokenCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tokenAmountInput),
                        onChange: function(e) {
                            return handleInputChange(e);
                        },
                        type: "number",
                        name: "amount"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Buttons_BlueButton_BlueButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: (_TokenCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().deployButton),
                        onClick: function() {
                            prop.createOTCBtnHandler((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prop.token), {
                                amount: BigInt(amount)
                            }));
                        },
                        children: [
                            "Create OTC ",
                            appStore.isProcessingTx === true && appStore.processingTxName === _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .TxEnums.OTC_CREATE */ .Rc.OTC_CREATE && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                        ]
                    })
                ]
            })
        ]
    });
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 29182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useTokenCard; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var INITIAL_IMAGE_SIZE = 65;
var useTokenCard = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("0"), amount = ref[0], setAmount = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(INITIAL_IMAGE_SIZE), imageSize = ref1[0], setImageSize = ref1[1];
    var handleInputChange = function(e) {
        setAmount(e.target.value);
    };
    return {
        amount: amount,
        imageSize: imageSize,
        handleInputChange: handleInputChange
    };
};


/***/ }),

/***/ 65175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Claim; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _useClaim__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39881);
/* harmony import */ var _Claim_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84346);
/* harmony import */ var _Claim_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Claim_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _SearchElement_SearchElement__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85005);
/* harmony import */ var _components_Common_Otc_Otc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38347);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_useClaim__WEBPACK_IMPORTED_MODULE_1__, _components_Common_Otc_Otc__WEBPACK_IMPORTED_MODULE_3__]);
([_useClaim__WEBPACK_IMPORTED_MODULE_1__, _components_Common_Otc_Otc__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
// Claim.tsx





function Claim(param) {
    var listOfOtcEntityWithTokens = param.listOfOtcEntityWithTokens, walletTokens = param.walletTokens;
    var ref = (0,_useClaim__WEBPACK_IMPORTED_MODULE_1__/* .useClaim */ .z)({
        listOfOtcEntityWithTokens: listOfOtcEntityWithTokens,
        walletTokens: walletTokens
    }), handleInputChange = ref.handleInputChange, filteredItems = ref.filteredItems;
    var itemsWithButtom = function() {
        var otcToClaimInterface = filteredItems;
        return otcToClaimInterface === null || otcToClaimInterface === void 0 ? void 0 : otcToClaimInterface.map(function(token) {
            return {
                token: token.tokens,
                btnHandler: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: (_Claim_module_scss__WEBPACK_IMPORTED_MODULE_4___default().claim),
                    onClick: token.btnHandler,
                    children: "Claim"
                })
            };
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_Claim_module_scss__WEBPACK_IMPORTED_MODULE_4___default().claimSection),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchElement_SearchElement__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                handleInputChange: handleInputChange
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_Otc_Otc__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                seccionCaption: "New's OTC",
                tokens: itemsWithButtom()
            })
        ]
    });
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 85005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SearchElement_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2302);
/* harmony import */ var _SearchElement_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_SearchElement_module_scss__WEBPACK_IMPORTED_MODULE_1__);
// SearchElement.tsx


function SearchElement(param) {
    var handleInputChange = param.handleInputChange;
    var svgSearch = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "SVGRepo_bgCarrier",
                strokeWidth: "0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "SVGRepo_tracerCarrier",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "SVGRepo_iconCarrier",
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M11 6C13.7614 6 16 8.23858 16 11M16.6588 16.6549L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z",
                        stroke: "#9FA1A7",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_SearchElement_module_scss__WEBPACK_IMPORTED_MODULE_1___default().searchContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            className: (_SearchElement_module_scss__WEBPACK_IMPORTED_MODULE_1___default().searchBox),
            children: [
                svgSearch,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    className: (_SearchElement_module_scss__WEBPACK_IMPORTED_MODULE_1___default().searchArea),
                    type: "text",
                    onChange: handleInputChange,
                    placeholder: "Search by name or policy ID"
                })
            ]
        })
    });
}


/***/ }),

/***/ 39881:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useClaim; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75971);
/* harmony import */ var _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1911);
/* harmony import */ var _lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3403);
/* harmony import */ var _contexts_AppState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37970);
/* harmony import */ var _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16573);
/* harmony import */ var _utils_constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23531);
/* harmony import */ var _contexts_ModalContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86662);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_2__, _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__, _lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_4__, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_6__]);
([smart_db__WEBPACK_IMPORTED_MODULE_2__, _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__, _lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_4__, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_6__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);











var useClaim = function(param) {
    var listOfOtcEntityWithTokens = param.listOfOtcEntityWithTokens, walletTokens = param.walletTokens;
    var walletStore = (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .useWalletStore */ .X$B)();
    //----------------------------------------------------------------------------
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_AppState__WEBPACK_IMPORTED_MODULE_5__/* .AppStateContext */ .z), appState = ref.appState, setAppState = ref.setAppState;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), searchTerm = ref1[0], setSearchTerm = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), tokenCardInterfaces = ref2[0], setTokenCardInterfaces = ref2[1];
    //-------------------------
    var openModal = (0,_contexts_ModalContext__WEBPACK_IMPORTED_MODULE_8__/* .useModal */ .d)().openModal;
    //-------------------------
    var resetForm = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                window.location.reload();
                return [
                    2
                ];
            });
        });
        return function resetForm() {
            return _ref.apply(this, arguments);
        };
    }();
    var onTx = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                return [
                    2
                ];
            });
        });
        return function onTx() {
            return _ref.apply(this, arguments);
        };
    }();
    function checkIsValidTx() {
        return _checkIsValidTx.apply(this, arguments);
    }
    function _checkIsValidTx() {
        _checkIsValidTx = //--------------------------------------
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var isValid;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                isValid = true;
                return [
                    2,
                    isValid
                ];
            });
        });
        return _checkIsValidTx.apply(this, arguments);
    }
    //--------------------------------------
    var dependenciesValidTx = [];
    var ref3 = (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .useTransactions */ .nCS)({
        dependenciesValidTx: dependenciesValidTx,
        checkIsValidTx: checkIsValidTx,
        onTx: onTx,
        resetForm: resetForm
    }), appStore = ref3.appStore, handleBtnDoTransaction_WithErrorControl = ref3.handleBtnDoTransaction_WithErrorControl;
    var debouncedSetSearchTerm = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default()(function(value) {
        return setSearchTerm(value);
    }, 100), []);
    var handleInputChange = function(event) {
        debouncedSetSearchTerm(event.target.value);
    };
    var claimBtnHandler = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(id) {
            var fetchParams, txApiCall, handleBtnTx;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (appStore.isProcessingTx === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_7__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                            return [
                                2
                            ];
                        }
                        fetchParams = function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                                var ref, lucid, emulatorDB, walletTxParams, txParams;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                smart_db__WEBPACK_IMPORTED_MODULE_2__/* .LucidToolsFrontEnd.prepareLucidFrontEndForTx */ .fmW.prepareLucidFrontEndForTx(walletStore)
                                            ];
                                        case 1:
                                            ref = _state.sent(), lucid = ref.lucid, emulatorDB = ref.emulatorDB, walletTxParams = ref.walletTxParams;
                                            txParams = {
                                                protocol_id: appState.protocol._DB_id,
                                                otcDbId: id
                                            };
                                            return [
                                                2,
                                                {
                                                    lucid: lucid,
                                                    emulatorDB: emulatorDB,
                                                    walletTxParams: walletTxParams,
                                                    txParams: txParams
                                                }
                                            ];
                                    }
                                });
                            });
                            return function fetchParams() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        //--------------------------------------
                        openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_7__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                        txApiCall = _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .OTCApi.callGenericTxApi.bind */ .N.callGenericTxApi.bind(_lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .OTCApi */ .N);
                        handleBtnTx = smart_db__WEBPACK_IMPORTED_MODULE_2__/* .BaseSmartDBFrontEndBtnHandlers.handleBtnDoTransaction_V2_NoErrorControl.bind */ .crd.handleBtnDoTransaction_V2_NoErrorControl.bind(smart_db__WEBPACK_IMPORTED_MODULE_2__/* .BaseSmartDBFrontEndBtnHandlers */ .crd);
                        //--------------------------------------
                        return [
                            4,
                            handleBtnDoTransaction_WithErrorControl(_lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_4__/* .OTCEntity */ .S, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_6__/* .TxEnums.OTC_CLAIM */ .Rc.OTC_CLAIM, "Claiming OTC ...", "claim-otc-tx", fetchParams, txApiCall, handleBtnTx)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        //--------------------------------------
        });
        return function claimBtnHandler(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var mapTokenToInterface = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(token) {
        return {
            tokens: token.metadata,
            btnHandler: function() {
                return claimBtnHandler(token.entity._DB_id);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!walletTokens || walletTokens.length === 0) {
            setTokenCardInterfaces([]);
            return;
        }
        var filtered = listOfOtcEntityWithTokens.filter(function(otcEntity) {
            return walletTokens.some(function(token) {
                return token.CS === otcEntity.entity.od_otc_nft_policy_id;
            }) && otcEntity.entity.od_creator !== walletStore.getPkh();
        });
        setTokenCardInterfaces(filtered.map(mapTokenToInterface));
    }, [
        listOfOtcEntityWithTokens,
        walletTokens,
        mapTokenToInterface
    ]);
    var filteredItems = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!searchTerm) return tokenCardInterfaces;
        var lowerSearchTerm = searchTerm.toLowerCase();
        return tokenCardInterfaces.filter(function(item) {
            return (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .hexToStr */ .NdO)(item.tokens.TN_Hex).toLowerCase().includes(lowerSearchTerm) || item.tokens.CS.toLowerCase().includes(lowerSearchTerm);
        });
    }, [
        searchTerm,
        tokenCardInterfaces
    ]);
    return {
        searchTerm: searchTerm,
        handleInputChange: handleInputChange,
        filteredItems: filteredItems
    };
};

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 40297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Home_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54143);
/* harmony import */ var _Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Home_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _useHome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97468);
/* harmony import */ var _components_Common_Buttons_ConnectWallet_BtnConnectWallet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68737);
/* harmony import */ var _ProtocolArea_ProtocolArea__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2906);
/* harmony import */ var _MyArea_MyArea__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87089);
/* harmony import */ var _Claim_Claim__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65175);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75971);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_useHome__WEBPACK_IMPORTED_MODULE_1__, _components_Common_Buttons_ConnectWallet_BtnConnectWallet__WEBPACK_IMPORTED_MODULE_2__, _ProtocolArea_ProtocolArea__WEBPACK_IMPORTED_MODULE_3__, _MyArea_MyArea__WEBPACK_IMPORTED_MODULE_4__, _Claim_Claim__WEBPACK_IMPORTED_MODULE_5__, smart_db__WEBPACK_IMPORTED_MODULE_6__]);
([_useHome__WEBPACK_IMPORTED_MODULE_1__, _components_Common_Buttons_ConnectWallet_BtnConnectWallet__WEBPACK_IMPORTED_MODULE_2__, _ProtocolArea_ProtocolArea__WEBPACK_IMPORTED_MODULE_3__, _MyArea_MyArea__WEBPACK_IMPORTED_MODULE_4__, _Claim_Claim__WEBPACK_IMPORTED_MODULE_5__, smart_db__WEBPACK_IMPORTED_MODULE_6__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
// Home.tsx








function Home() {
    var renderHome = //--------------------------------------
    function renderHome() {
        if (!isWalletConnected) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Please connect, your wallet"
            });
        }
        switch(sidebarState){
            case "Protocol Area":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProtocolArea_ProtocolArea__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
            case "Claim":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Claim_Claim__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    walletTokens: walletTokens,
                    listOfOtcEntityWithTokens: listOfOtcEntityWithTokens
                });
            case "My Area":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MyArea_MyArea__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    walletTokens: walletTokens,
                    listOfOtcEntityWithTokens: listOfOtcEntityWithTokens
                });
            default:
                return null;
        }
    };
    var ref = (0,_useHome__WEBPACK_IMPORTED_MODULE_1__/* .useHome */ ._)(), appState = ref.appState, sidebarState = ref.sidebarState, isWalletConnected = ref.isWalletConnected, listOfOtcEntityWithTokens = ref.listOfOtcEntityWithTokens, walletTokens = ref.walletTokens;
    //--------------------------------------
    // para que cargue la sesion del wallet
    (0,smart_db__WEBPACK_IMPORTED_MODULE_6__/* .useWalletSession */ .lTY)();
    //--------------------------------------
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().mainSection),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().mainContainer),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().card),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cardHeader),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                className: (_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cardCaption),
                                children: " $MAYZ - Over The Counter"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_Buttons_ConnectWallet_BtnConnectWallet__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().protocolMessage),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: appState.protocol === undefined ? "Please Create Protocol" : "Protocol: ".concat(appState.protocol.name)
                        })
                    }),
                    renderHome()
                ]
            })
        })
    });
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 87089:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Common_Otc_Otc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38347);
/* harmony import */ var _MyArea_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66110);
/* harmony import */ var _MyArea_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_MyArea_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _useMyArea__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3051);
/* harmony import */ var _YourTokenSeccion_YourTokenSeccion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76240);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_components_Common_Otc_Otc__WEBPACK_IMPORTED_MODULE_1__, _useMyArea__WEBPACK_IMPORTED_MODULE_2__, _YourTokenSeccion_YourTokenSeccion__WEBPACK_IMPORTED_MODULE_3__]);
([_components_Common_Otc_Otc__WEBPACK_IMPORTED_MODULE_1__, _useMyArea__WEBPACK_IMPORTED_MODULE_2__, _YourTokenSeccion_YourTokenSeccion__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
// MyArea.tsx








function MyArea(param) {
    var walletTokens = param.walletTokens, listOfOtcEntityWithTokens = param.listOfOtcEntityWithTokens;
    var ref = (0,_useMyArea__WEBPACK_IMPORTED_MODULE_2__/* .useMyArea */ .E)({
        walletTokens: walletTokens,
        listOfOtcEntityWithTokens: listOfOtcEntityWithTokens
    }), tokensOTCToCancelInterface = ref.tokensOTCToCancelInterface, tokensOTCToCloseInterface = ref.tokensOTCToCloseInterface, createOTCBtnHandler = ref.createOTCBtnHandler;
    //---------------------------------------------------
    var otcUnions = function() {
        var cancelElem = tokensOTCToCancelInterface === null || tokensOTCToCancelInterface === void 0 ? void 0 : tokensOTCToCancelInterface.map(function(token) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, token), {
                btnHandler: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: (_MyArea_module_scss__WEBPACK_IMPORTED_MODULE_6___default().cancel),
                    onClick: token.btnHandler,
                    children: "Cancel"
                })
            });
        });
        var closeElem = tokensOTCToCloseInterface === null || tokensOTCToCloseInterface === void 0 ? void 0 : tokensOTCToCloseInterface.map(function(token) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, token), {
                btnHandler: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: (_MyArea_module_scss__WEBPACK_IMPORTED_MODULE_6___default().close),
                    onClick: token.btnHandler,
                    children: "Close"
                })
            });
        });
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(cancelElem).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(closeElem));
    };
    //---------------------------------------------------
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_MyArea_module_scss__WEBPACK_IMPORTED_MODULE_6___default().myAreaSection),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_YourTokenSeccion_YourTokenSeccion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                walletTokens: walletTokens,
                createOTCBtnHandler: createOTCBtnHandler
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_Otc_Otc__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                seccionCaption: "Your Open OTC",
                tokens: otcUnions()
            })
        ]
    });
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 76240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ YourTokenSeccion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Common_TokenCard_TokenCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75610);
/* harmony import */ var _YourTokenSeccion_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64206);
/* harmony import */ var _YourTokenSeccion_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_YourTokenSeccion_module_scss__WEBPACK_IMPORTED_MODULE_2__);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_components_Common_TokenCard_TokenCard__WEBPACK_IMPORTED_MODULE_1__]);
_components_Common_TokenCard_TokenCard__WEBPACK_IMPORTED_MODULE_1__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
// YourTokenSeccion.tsx



function YourTokenSeccion(props) {
    var tokens = function() {
        var ref;
        return (ref = props.walletTokens) === null || ref === void 0 ? void 0 : ref.map(function(token) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_TokenCard_TokenCard__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                token: token,
                createOTCBtnHandler: props.createOTCBtnHandler
            }, token.TN_Hex);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_YourTokenSeccion_module_scss__WEBPACK_IMPORTED_MODULE_2___default().yourTokenSeccionContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_YourTokenSeccion_module_scss__WEBPACK_IMPORTED_MODULE_2___default().seccionCaption),
                children: "Your tokens"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_YourTokenSeccion_module_scss__WEBPACK_IMPORTED_MODULE_2___default().separator)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_YourTokenSeccion_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tokenGrid),
                children: tokens()
            })
        ]
    });
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 3051:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useMyArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var _contexts_AppState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37970);
/* harmony import */ var _contexts_ModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86662);
/* harmony import */ var _utils_constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23531);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75971);
/* harmony import */ var _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16573);
/* harmony import */ var _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1911);
/* harmony import */ var _lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3403);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_4__, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__, _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_6__, _lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_7__]);
([smart_db__WEBPACK_IMPORTED_MODULE_4__, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__, _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_6__, _lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_7__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);











var useMyArea = function(props) {
    //----------------------------------------------------------------------------
    var walletTokens = props.walletTokens, listOfOtcEntityWithTokens = props.listOfOtcEntityWithTokens;
    //----------------------------------------------------------------------------
    var walletStore = (0,smart_db__WEBPACK_IMPORTED_MODULE_4__/* .useWalletStore */ .X$B)();
    //----------------------------------------------------------------------------
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_contexts_AppState__WEBPACK_IMPORTED_MODULE_0__/* .AppStateContext */ .z), appState = ref.appState, setAppState = ref.setAppState;
    //-------------------------
    //-------------------------
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), tokensOTCsOfUser = ref1[0], setTokensOTCsOfUser = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), tokensOTCToCancelInterface = ref2[0], setTokensOTCsToCancelInterface = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), tokensOTCToCloseInterface = ref3[0], setTokensOTCsToCloseInterface = ref3[1];
    //-------------------------
    var openModal = (0,_contexts_ModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)().openModal;
    //-------------------------
    var resetForm = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                return [
                    2
                ];
            });
        });
        return function resetForm() {
            return _ref.apply(this, arguments);
        };
    }();
    var onTx = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                window.location.reload();
                return [
                    2
                ];
            });
        });
        return function onTx() {
            return _ref.apply(this, arguments);
        };
    }();
    function checkIsValidTx() {
        return _checkIsValidTx.apply(this, arguments);
    }
    function _checkIsValidTx() {
        _checkIsValidTx = //--------------------------------------
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var isValid;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                isValid = true;
                return [
                    2,
                    isValid
                ];
            });
        });
        return _checkIsValidTx.apply(this, arguments);
    }
    //--------------------------------------
    var dependenciesValidTx = [];
    //--------------------------------------
    var ref4 = (0,smart_db__WEBPACK_IMPORTED_MODULE_4__/* .useTransactions */ .nCS)({
        dependenciesValidTx: dependenciesValidTx,
        checkIsValidTx: checkIsValidTx,
        onTx: onTx,
        resetForm: resetForm
    }), appStore = ref4.appStore, handleBtnDoTransaction_WithErrorControl = ref4.handleBtnDoTransaction_WithErrorControl;
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var tokens = listOfOtcEntityWithTokens.filter(function(otcEntity) {
            var ref;
            return otcEntity.entity.od_creator === ((ref = walletStore.info) === null || ref === void 0 ? void 0 : ref.pkh);
        });
        setTokensOTCsOfUser(tokens);
        if (!walletTokens) {
            return;
        }
        var otcToCancel = tokens.filter(function(otcEntity) {
            return walletTokens.some(function(token) {
                return token.CS === otcEntity.entity.od_otc_nft_policy_id;
            });
        });
        var otcToClose = tokens.filter(function(otcEntity) {
            return !walletTokens.some(function(token) {
                return token.CS === otcEntity.entity.od_otc_nft_policy_id;
            });
        });
        var mapTokenToInterface = function(token, handler) {
            return {
                token: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, token.metadata),
                btnHandler: function() {
                    return handler(token.entity._DB_id);
                }
            };
        };
        var otcToCancelInterface = otcToCancel.map(function(token) {
            return mapTokenToInterface(token, cancelBtnHandler);
        });
        var otcToCloseInterface = otcToClose.map(function(token) {
            return mapTokenToInterface(token, closeBtnHandler);
        });
        setTokensOTCsToCancelInterface(otcToCancelInterface);
        setTokensOTCsToCloseInterface(otcToCloseInterface);
    }, [
        listOfOtcEntityWithTokens,
        walletTokens
    ]);
    function cancelBtnHandler(id) {
        return _cancelBtnHandler.apply(this, arguments);
    }
    function _cancelBtnHandler() {
        _cancelBtnHandler = //--------------------------------------
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(id) {
            var fetchParams, txApiCall, handleBtnTx;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (appStore.isProcessingTx === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                            return [
                                2
                            ];
                        }
                        fetchParams = function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                                var ref, lucid, emulatorDB, walletTxParams, txParams;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                smart_db__WEBPACK_IMPORTED_MODULE_4__/* .LucidToolsFrontEnd.prepareLucidFrontEndForTx */ .fmW.prepareLucidFrontEndForTx(walletStore)
                                            ];
                                        case 1:
                                            ref = _state.sent(), lucid = ref.lucid, emulatorDB = ref.emulatorDB, walletTxParams = ref.walletTxParams;
                                            txParams = {
                                                protocol_id: appState.protocol._DB_id,
                                                otcDbId: id
                                            };
                                            return [
                                                2,
                                                {
                                                    lucid: lucid,
                                                    emulatorDB: emulatorDB,
                                                    walletTxParams: walletTxParams,
                                                    txParams: txParams
                                                }
                                            ];
                                    }
                                });
                            });
                            return function fetchParams() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        //--------------------------------------
                        openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                        txApiCall = _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_6__/* .OTCApi.callGenericTxApi.bind */ .N.callGenericTxApi.bind(_lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_6__/* .OTCApi */ .N);
                        handleBtnTx = smart_db__WEBPACK_IMPORTED_MODULE_4__/* .BaseSmartDBFrontEndBtnHandlers.handleBtnDoTransaction_V2_NoErrorControl.bind */ .crd.handleBtnDoTransaction_V2_NoErrorControl.bind(smart_db__WEBPACK_IMPORTED_MODULE_4__/* .BaseSmartDBFrontEndBtnHandlers */ .crd);
                        //--------------------------------------
                        return [
                            4,
                            handleBtnDoTransaction_WithErrorControl(_lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_7__/* .OTCEntity */ .S, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .TxEnums.OTC_CANCEL */ .Rc.OTC_CANCEL, "Cancel OTC ...", "cancel-otc-tx", fetchParams, txApiCall, handleBtnTx)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        //--------------------------------------
        // await fetchProtocol();
        });
        return _cancelBtnHandler.apply(this, arguments);
    }
    function closeBtnHandler(id) {
        return _closeBtnHandler.apply(this, arguments);
    }
    function _closeBtnHandler() {
        _closeBtnHandler = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(id) {
            var fetchParams, txApiCall, handleBtnTx;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (appStore.isProcessingTx === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                            return [
                                2
                            ];
                        }
                        fetchParams = function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                                var ref, lucid, emulatorDB, walletTxParams, txParams;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                smart_db__WEBPACK_IMPORTED_MODULE_4__/* .LucidToolsFrontEnd.prepareLucidFrontEndForTx */ .fmW.prepareLucidFrontEndForTx(walletStore)
                                            ];
                                        case 1:
                                            ref = _state.sent(), lucid = ref.lucid, emulatorDB = ref.emulatorDB, walletTxParams = ref.walletTxParams;
                                            txParams = {
                                                protocol_id: appState.protocol._DB_id,
                                                otcDbId: id
                                            };
                                            return [
                                                2,
                                                {
                                                    lucid: lucid,
                                                    emulatorDB: emulatorDB,
                                                    walletTxParams: walletTxParams,
                                                    txParams: txParams
                                                }
                                            ];
                                    }
                                });
                            });
                            return function fetchParams() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        //--------------------------------------
                        openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                        txApiCall = _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_6__/* .OTCApi.callGenericTxApi.bind */ .N.callGenericTxApi.bind(_lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_6__/* .OTCApi */ .N);
                        handleBtnTx = smart_db__WEBPACK_IMPORTED_MODULE_4__/* .BaseSmartDBFrontEndBtnHandlers.handleBtnDoTransaction_V2_NoErrorControl.bind */ .crd.handleBtnDoTransaction_V2_NoErrorControl.bind(smart_db__WEBPACK_IMPORTED_MODULE_4__/* .BaseSmartDBFrontEndBtnHandlers */ .crd);
                        //--------------------------------------
                        return [
                            4,
                            handleBtnDoTransaction_WithErrorControl(_lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_7__/* .OTCEntity */ .S, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .TxEnums.OTC_CLOSE */ .Rc.OTC_CLOSE, "Close OTC ...", "close-otc-tx", fetchParams, txApiCall, handleBtnTx)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        //--------------------------------------
        });
        return _closeBtnHandler.apply(this, arguments);
    }
    //-------------------------
    // Function to handle the sell transaction for a specific asset
    var createOTCBtnHandler = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(token) {
            var fetchParams, txApiCall, handleBtnTx;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (appStore.isProcessingTx === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                            return [
                                2
                            ];
                        }
                        fetchParams = function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                                var ref, lucid, emulatorDB, walletTxParams, txParams;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                smart_db__WEBPACK_IMPORTED_MODULE_4__/* .LucidToolsFrontEnd.prepareLucidFrontEndForTx */ .fmW.prepareLucidFrontEndForTx(walletStore)
                                            ];
                                        case 1:
                                            ref = _state.sent(), lucid = ref.lucid, emulatorDB = ref.emulatorDB, walletTxParams = ref.walletTxParams;
                                            txParams = {
                                                protocol_id: appState.protocol._DB_id,
                                                od_token_policy_id: token.CS,
                                                od_token_tn: token.TN_Hex,
                                                od_token_amount: token.amount
                                            };
                                            return [
                                                2,
                                                {
                                                    lucid: lucid,
                                                    emulatorDB: emulatorDB,
                                                    walletTxParams: walletTxParams,
                                                    txParams: txParams
                                                }
                                            ];
                                    }
                                });
                            });
                            return function fetchParams() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        //--------------------------------------
                        openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                        txApiCall = _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_6__/* .OTCApi.callGenericTxApi.bind */ .N.callGenericTxApi.bind(_lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_6__/* .OTCApi */ .N);
                        handleBtnTx = smart_db__WEBPACK_IMPORTED_MODULE_4__/* .BaseSmartDBFrontEndBtnHandlers.handleBtnDoTransaction_V2_NoErrorControl.bind */ .crd.handleBtnDoTransaction_V2_NoErrorControl.bind(smart_db__WEBPACK_IMPORTED_MODULE_4__/* .BaseSmartDBFrontEndBtnHandlers */ .crd);
                        //--------------------------------------
                        return [
                            4,
                            handleBtnDoTransaction_WithErrorControl(_lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_7__/* .OTCEntity */ .S, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .TxEnums.OTC_CREATE */ .Rc.OTC_CREATE, "Creating OTC FT...", "create-otc-tx", fetchParams, txApiCall, handleBtnTx)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        //--------------------------------------
        });
        return function createOTCBtnHandler(token) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        tokensOTCsOfUser: tokensOTCsOfUser,
        tokensOTCToCancelInterface: tokensOTCToCancelInterface,
        tokensOTCToCloseInterface: tokensOTCToCloseInterface,
        createOTCBtnHandler: createOTCBtnHandler
    };
};

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 2906:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProtocolArea; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16573);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75971);
/* harmony import */ var _ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36581);
/* harmony import */ var _ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78470);
/* harmony import */ var _components_Common_Buttons_BlueButton_BlueButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69522);
/* harmony import */ var _useProtocolArea__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2460);
/* harmony import */ var _utils_constants_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23531);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_1__, smart_db__WEBPACK_IMPORTED_MODULE_2__, _useProtocolArea__WEBPACK_IMPORTED_MODULE_5__]);
([_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_1__, smart_db__WEBPACK_IMPORTED_MODULE_2__, _useProtocolArea__WEBPACK_IMPORTED_MODULE_5__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
// ProtocolArea.tsx








function ProtocolArea() {
    var ref = (0,_useProtocolArea__WEBPACK_IMPORTED_MODULE_5__/* .useProtocolArea */ .S)(), appState = ref.appState, appStore = ref.appStore, pdAdmins = ref.pdAdmins, setPdAdmins = ref.setPdAdmins, pdTokenAdminPolicy_CS = ref.pdTokenAdminPolicy_CS, setPdTokenAdminPolicy_CS = ref.setPdTokenAdminPolicy_CS, pd_mayz_deposit_requirement = ref.pd_mayz_deposit_requirement, set_pd_mayz_deposit_requirement = ref.set_pd_mayz_deposit_requirement, error = ref.error, handleCreateProtocol = ref.handleCreateProtocol, handleDeployProtocol = ref.handleDeployProtocol, handleSyncProtocol = ref.handleSyncProtocol, handleAddTokens = ref.handleAddTokens, handleDeleteProtocol = ref.handleDeleteProtocol, handleUpdateProtocol = ref.handleUpdateProtocol;
    //--------------------------------------
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().protocolAreaSection),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().form),
                children: appState.protocol === undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Common_Buttons_BlueButton_BlueButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    style: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btnAction),
                    onClick: handleCreateProtocol,
                    children: [
                        "Create Protocol ",
                        appStore.isProcessingTask === true && appStore.processingTaskName === _utils_constants_constants__WEBPACK_IMPORTED_MODULE_6__/* .TaskEnums.CREATE_PROTOCOL */ .Xz.CREATE_PROTOCOL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                    ]
                }) : appState.protocol._isDeployed === false ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().formGroup),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    children: "Admin Payment Key Hashes"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    value: pdAdmins,
                                    onChange: function(e) {
                                        return setPdAdmins(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().formGroup),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    children: "Admin Token Currency Symbol"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    value: pdTokenAdminPolicy_CS,
                                    onChange: function(e) {
                                        return setPdTokenAdminPolicy_CS(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().formGroup),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    htmlFor: "pd_mayz_deposit_requirement",
                                    children: "gMAYZ Required for OTC:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "number",
                                    id: "pd_mayz_deposit_requirement",
                                    name: "pd_mayz_deposit_requirement",
                                    value: pd_mayz_deposit_requirement,
                                    onChange: function(e) {
                                        return set_pd_mayz_deposit_requirement(e.target.value);
                                    },
                                    min: "0"
                                })
                            ]
                        }),
                        !(0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .isNullOrBlank */ .Xy7)(error) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().errorMessage),
                            children: error
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Common_Buttons_BlueButton_BlueButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            style: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btnAction),
                            onClick: handleDeployProtocol,
                            children: [
                                "Deploy ",
                                appStore.isProcessingTx === true && appStore.processingTxName === _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_1__/* .TxEnums.PROTOCOL_DEPLOY */ .Rc.PROTOCOL_DEPLOY && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Common_Buttons_BlueButton_BlueButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            style: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btnAction),
                            onClick: handleSyncProtocol,
                            children: [
                                "Sync ",
                                appStore.isProcessingTask === true && appStore.processingTaskName === _utils_constants_constants__WEBPACK_IMPORTED_MODULE_6__/* .TaskEnums.SYNC_PROTOCOL */ .Xz.SYNC_PROTOCOL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                            ]
                        }),
                        smart_db__WEBPACK_IMPORTED_MODULE_2__/* .isEmulator */ .Itp && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Common_Buttons_BlueButton_BlueButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            style: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btnAction),
                            onClick: handleAddTokens,
                            children: [
                                "[TEST] Add Tokens ",
                                appStore.isProcessingTask === true && appStore.processingTaskName === _utils_constants_constants__WEBPACK_IMPORTED_MODULE_6__/* .TaskEnums.ADD_TEST_TOKENS */ .Xz.ADD_TEST_TOKENS && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Common_Buttons_BlueButton_BlueButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            style: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btnAction),
                            onClick: handleDeleteProtocol,
                            children: [
                                "Delete ",
                                appStore.isProcessingTask === true && appStore.processingTaskName === _utils_constants_constants__WEBPACK_IMPORTED_MODULE_6__/* .TaskEnums.DELETE_PROTOCOL */ .Xz.DELETE_PROTOCOL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().formGroup),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    children: "Admin Payment Key Hashes"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    value: pdAdmins,
                                    onChange: function(e) {
                                        return setPdAdmins(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().formGroup),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    children: "Admin Token Currency Symbol"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    value: pdTokenAdminPolicy_CS,
                                    onChange: function(e) {
                                        return setPdTokenAdminPolicy_CS(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().formGroup),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    htmlFor: "pd_mayz_deposit_requirement",
                                    children: "gMAYZ Required for OTC:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "number",
                                    id: "pd_mayz_deposit_requirement",
                                    name: "pd_mayz_deposit_requirement",
                                    value: pd_mayz_deposit_requirement,
                                    onChange: function(e) {
                                        return set_pd_mayz_deposit_requirement(e.target.value);
                                    },
                                    min: "0"
                                })
                            ]
                        }),
                        !(0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .isNullOrBlank */ .Xy7)(error) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().errorMessage),
                            children: error
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Common_Buttons_BlueButton_BlueButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            style: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btnAction),
                            onClick: handleUpdateProtocol,
                            children: [
                                "Update ",
                                appStore.isProcessingTx === true && appStore.processingTxName === _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_1__/* .TxEnums.PROTOCOL_UPDATE */ .Rc.PROTOCOL_UPDATE && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Common_Buttons_BlueButton_BlueButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            style: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btnAction),
                            onClick: handleSyncProtocol,
                            children: [
                                "Sync ",
                                appStore.isProcessingTask === true && appStore.processingTaskName === _utils_constants_constants__WEBPACK_IMPORTED_MODULE_6__/* .TaskEnums.SYNC_PROTOCOL */ .Xz.SYNC_PROTOCOL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                            ]
                        }),
                        smart_db__WEBPACK_IMPORTED_MODULE_2__/* .isEmulator */ .Itp && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Common_Buttons_BlueButton_BlueButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            style: (_ProtocolArea_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btnAction),
                            onClick: handleAddTokens,
                            children: [
                                "[TEST] Add Tokens ",
                                appStore.isProcessingTask === true && appStore.processingTaskName === _utils_constants_constants__WEBPACK_IMPORTED_MODULE_6__/* .TaskEnums.ADD_TEST_TOKENS */ .Xz.ADD_TEST_TOKENS && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                            ]
                        })
                    ]
                })
            })
        })
    });
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 2460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useProtocolArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var _contexts_AppState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37970);
/* harmony import */ var _contexts_ModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86662);
/* harmony import */ var _lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3403);
/* harmony import */ var _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1911);
/* harmony import */ var _utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23531);
/* harmony import */ var _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16573);
/* harmony import */ var _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76100);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75971);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_2__, _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__, _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__, smart_db__WEBPACK_IMPORTED_MODULE_8__]);
([_lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_2__, _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__, _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__, smart_db__WEBPACK_IMPORTED_MODULE_8__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);














var useProtocolArea = function() {
    var ref, ref1, ref2, ref3, ref4;
    //-------------------------
    var walletStore = (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .useWalletStore */ .X$B)();
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useContext)(_contexts_AppState__WEBPACK_IMPORTED_MODULE_0__/* .AppStateContext */ .z), appState = ref5.appState, setAppState = ref5.setAppState;
    //-------------------------
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(((ref = appState.protocol) === null || ref === void 0 ? void 0 : (ref1 = ref.pd_admins) === null || ref1 === void 0 ? void 0 : ref1.join(",")) || ""), pdAdmins = ref6[0], setPdAdmins = ref6[1];
    var ref7;
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)((ref7 = (ref2 = appState.protocol) === null || ref2 === void 0 ? void 0 : ref2.pd_mayz_policy_id) !== null && ref7 !== void 0 ? ref7 : _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .ADMIN_TOKEN_POLICY_CS */ .tz), pdTokenAdminPolicy_CS = ref8[0], setPdTokenAdminPolicy_CS = ref8[1];
    var ref9;
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)((ref9 = (ref3 = appState.protocol) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.pd_mayz_deposit_requirement) === null || ref4 === void 0 ? void 0 : ref4.toString()) !== null && ref9 !== void 0 ? ref9 : ""), pd_mayz_deposit_requirement = ref10[0], set_pd_mayz_deposit_requirement = ref10[1];
    //-------------------------
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), error = ref11[0], setError = ref11[1];
    //-------------------------
    var openModal = (0,_contexts_ModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)().openModal;
    //-------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (walletStore.isConnected === true && walletStore.info !== undefined) {
            if (pdAdmins === "") {
                setPdAdmins(walletStore.info.pkh);
            }
        }
    }, [
        walletStore.isConnected
    ]);
    //-------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (appState.protocol !== undefined) {
            var ref, ref1, ref2;
            if (walletStore.isConnected === true && walletStore.info !== undefined) {
                if (pdAdmins === "") {
                    setPdAdmins(walletStore.info.pkh);
                }
            } else {
                var ref3, ref4;
                setPdAdmins(((ref3 = appState.protocol) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.pd_admins) === null || ref4 === void 0 ? void 0 : ref4.join(",")) || "");
            }
            var ref5;
            setPdTokenAdminPolicy_CS((ref5 = (ref = appState.protocol) === null || ref === void 0 ? void 0 : ref.pd_mayz_policy_id) !== null && ref5 !== void 0 ? ref5 : _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .ADMIN_TOKEN_POLICY_CS */ .tz);
            var ref6;
            set_pd_mayz_deposit_requirement((ref6 = (ref1 = appState.protocol) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pd_mayz_deposit_requirement) === null || ref2 === void 0 ? void 0 : ref2.toString()) !== null && ref6 !== void 0 ? ref6 : "");
        }
    }, [
        appState.protocol
    ]);
    //-------------------------
    var fetchProtocol = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var protocol;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .ProtocolApi.getOneByParamsApi_ */ .O.getOneByParamsApi_()
                        ];
                    case 1:
                        protocol = _state.sent();
                        // Update the context
                        setAppState(function(prev) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prev), {
                                protocol: protocol
                            });
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchProtocol() {
            return _ref.apply(this, arguments);
        };
    }();
    //-------------------------
    var resetForm = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                setError(null);
                return [
                    2
                ];
            });
        });
        return function resetForm() {
            return _ref.apply(this, arguments);
        };
    }();
    var onTx = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchProtocol()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onTx() {
            return _ref.apply(this, arguments);
        };
    }();
    function checkIsValidTx() {
        return _checkIsValidTx.apply(this, arguments);
    }
    function _checkIsValidTx() {
        _checkIsValidTx = //--------------------------------------
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var isValid;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                isValid = true;
                return [
                    2,
                    isValid
                ];
            });
        });
        return _checkIsValidTx.apply(this, arguments);
    }
    //--------------------------------------
    var dependenciesValidTx = [];
    //--------------------------------------
    var ref12 = (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .useTransactions */ .nCS)({
        dependenciesValidTx: dependenciesValidTx,
        checkIsValidTx: checkIsValidTx,
        onTx: onTx,
        resetForm: resetForm
    }), appStore = ref12.appStore, tokensStore = ref12.tokensStore, session = ref12.session, status = ref12.status, showUserConfirmation = ref12.showUserConfirmation, setShowUserConfirmation = ref12.setShowUserConfirmation, showProcessingTx = ref12.showProcessingTx, setShowProcessingTx = ref12.setShowProcessingTx, isProcessingTx = ref12.isProcessingTx, setIsProcessingTx = ref12.setIsProcessingTx, isFaildedTx = ref12.isFaildedTx, setIsFaildedTx = ref12.setIsFaildedTx, isConfirmedTx = ref12.isConfirmedTx, setIsConfirmedTx = ref12.setIsConfirmedTx, processingTxMessage = ref12.processingTxMessage, setProcessingTxMessage = ref12.setProcessingTxMessage, processingTxHash = ref12.processingTxHash, setProcessingTxHash = ref12.setProcessingTxHash, isValidTx = ref12.isValidTx, setIsValidTx = ref12.setIsValidTx, tokensGiveWithMetadata = ref12.tokensGiveWithMetadata, setTokensGiveWithMetadata = ref12.setTokensGiveWithMetadata, tokensGetWithMetadata = ref12.tokensGetWithMetadata, setTokensGetWithMetadata = ref12.setTokensGetWithMetadata, available_ADA_in_Wallet = ref12.available_ADA_in_Wallet, available_forSpend_ADA_in_Wallet = ref12.available_forSpend_ADA_in_Wallet, isMaxAmountLoadedFromTxHook = ref12.isMaxAmountLoaded, handleBtnShowUserConfirmation = ref12.handleBtnShowUserConfirmation, handleBtnDoTransaction_WithErrorControl = ref12.handleBtnDoTransaction_WithErrorControl;
    //--------------------------------------
    var handleCreateProtocol = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var ref, lucid, emulatorDB, walletTxParams, walletUTxOs, uTxO, pp_protocol_TxHash, pp_protocol_TxOutputIndex, oRef, protocolParams, fProtocolScript_Params, fProtocolScript, fProtocolPolicyID_CS, fProtocolValidator_Hash, fProtocolValidator_AddressTestnet, fProtocolValidator_AddressMainnet, otcParams, fOTCScript_Params, fOTCScript, fOTCPolicyID_CS, fOTCValidator_Hash, fOTCValidator_AddressTestnet, fOTCValidator_AddressMainnet, fOTC_NFT_PRE_Script, protocol, protocol_, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (appStore.isProcessingTx === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                            return [
                                2
                            ];
                        }
                        if (appStore.isProcessingTask === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TASK */ .DC.PROCESSING_TASK);
                            return [
                                2
                            ];
                        }
                        if (!confirm("Are you sure you want to create the protocol?")) return [
                            3,
                            8
                        ];
                        //--------------------------------------
                        appStore.setProcessingTaskName(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .TaskEnums.CREATE_PROTOCOL */ .Xz.CREATE_PROTOCOL);
                        appStore.setIsProcessingTask(true);
                        appStore.setIsConfirmedTask(false);
                        appStore.setIsFaildedTask(false);
                        //--------------------------------------
                        appStore.setProcessingTaskMessage("Creating Protocol...");
                        openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TASK */ .DC.PROCESSING_TASK);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        return [
                            4,
                            smart_db__WEBPACK_IMPORTED_MODULE_8__/* .LucidToolsFrontEnd.prepareLucidFrontEndForTx */ .fmW.prepareLucidFrontEndForTx(walletStore)
                        ];
                    case 2:
                        ref = _state.sent(), lucid = ref.lucid, emulatorDB = ref.emulatorDB, walletTxParams = ref.walletTxParams;
                        walletUTxOs = walletTxParams.utxos;
                        if (walletUTxOs.length === 0) {
                            throw "You need at least one utxo to be used to mint Protocol ID";
                        }
                        uTxO = walletUTxOs[0];
                        console.log("uTxO for creating Protocol ID: ".concat((0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .formatUTxO */ .sa8)(uTxO.txHash, uTxO.outputIndex)));
                        pp_protocol_TxHash = uTxO.txHash;
                        pp_protocol_TxOutputIndex = uTxO.outputIndex;
                        oRef = new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .Constr */ .fL(0, [
                            pp_protocol_TxHash,
                            BigInt(pp_protocol_TxOutputIndex)
                        ]);
                        protocolParams = new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .Constr */ .fL(0, [
                            oRef,
                            (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .strToHex */ .pzN)(_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .PROTOCOL_ID_TN_Str */ .Q8)
                        ]);
                        fProtocolScript_Params = {
                            pp_protocol_policy_id_tx_out_ref: {
                                txid: pp_protocol_TxHash,
                                tx_index: pp_protocol_TxOutputIndex
                            },
                            pp_protocol_id_tn: (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .strToHex */ .pzN)(_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .PROTOCOL_ID_TN_Str */ .Q8)
                        };
                        fProtocolScript = {
                            type: "PlutusV3",
                            script: (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .applyParamsToScript */ .eI)(_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .PROTOCOL_SCRIPT_PRE_CBORHEX */ .wz, [
                                protocolParams
                            ])
                        };
                        fProtocolPolicyID_CS = (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .mintingPolicyToId */ .of)(fProtocolScript);
                        console.log("fProtocolPolicyID_CS ".concat(fProtocolPolicyID_CS));
                        fProtocolValidator_Hash = (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .validatorToScriptHash */ .aI)(fProtocolScript);
                        console.log("fProtocolValidator_Hash ".concat(fProtocolValidator_Hash));
                        fProtocolValidator_AddressTestnet = (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .validatorToAddress */ .nz)(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .LUCID_NETWORK_PREVIEW_NAME */ .TuU, fProtocolScript);
                        console.log("fProtocolValidator_AddressTestnet ".concat(fProtocolValidator_AddressTestnet));
                        fProtocolValidator_AddressMainnet = (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .validatorToAddress */ .nz)(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .LUCID_NETWORK_MAINNET_NAME */ .Pem, fProtocolScript);
                        console.log("fProtocolValidator_AddressMainnet ".concat(fProtocolValidator_AddressMainnet));
                        otcParams = new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .Constr */ .fL(0, [
                            fProtocolPolicyID_CS,
                            (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .strToHex */ .pzN)(_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .PROTOCOL_ID_TN_Str */ .Q8),
                            (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .strToHex */ .pzN)(_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .OTC_ID_TN_Str */ .VP)
                        ]);
                        fOTCScript_Params = {
                            pp_protocol_policy_id: fProtocolPolicyID_CS,
                            pp_protocol_id_tn: (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .strToHex */ .pzN)(_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .PROTOCOL_ID_TN_Str */ .Q8),
                            pp_otc_id_tn: (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .strToHex */ .pzN)(_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .OTC_ID_TN_Str */ .VP)
                        };
                        fOTCScript = {
                            type: "PlutusV3",
                            script: (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .applyParamsToScript */ .eI)(_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .OTC_SCRIPT_PRE_CBORHEX */ .oH, [
                                otcParams
                            ])
                        };
                        fOTCPolicyID_CS = (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .mintingPolicyToId */ .of)(fOTCScript);
                        console.log("fOTCPolicyID_CS ".concat(fOTCPolicyID_CS));
                        fOTCValidator_Hash = (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .validatorToScriptHash */ .aI)(fOTCScript);
                        console.log("fOTCValidator_Hash ".concat(fOTCValidator_Hash));
                        fOTCValidator_AddressTestnet = (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .validatorToAddress */ .nz)(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .LUCID_NETWORK_PREVIEW_NAME */ .TuU, fOTCScript);
                        console.log("fOTCValidator_AddressTestnet ".concat(fOTCValidator_AddressTestnet));
                        fOTCValidator_AddressMainnet = (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_6__/* .validatorToAddress */ .nz)(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .LUCID_NETWORK_MAINNET_NAME */ .Pem, fOTCScript);
                        console.log("fOTCValidator_AddressMainnet ".concat(fOTCValidator_AddressMainnet));
                        fOTC_NFT_PRE_Script = {
                            type: "PlutusV3",
                            script: _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .OTC_NFT_POLICY_PRE_CBORHEX */ .h
                        };
                        protocol = new _lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_2__/* .ProtocolEntity */ .A({
                            name: smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t,
                            fProtocolScript: fProtocolScript,
                            fProtocolScript_Params: fProtocolScript_Params,
                            fProtocolPolicyID_CS: fProtocolPolicyID_CS,
                            fProtocolValidator_AddressMainnet: fProtocolValidator_AddressMainnet,
                            fProtocolValidator_AddressTestnet: fProtocolValidator_AddressTestnet,
                            fProtocolValidator_Hash: fProtocolValidator_Hash,
                            fOTCScript: fOTCScript,
                            fOTCScript_Params: fOTCScript_Params,
                            fOTCPolicyID_CS: fOTCPolicyID_CS,
                            fOTCValidator_AddressMainnet: fOTCValidator_AddressMainnet,
                            fOTCValidator_AddressTestnet: fOTCValidator_AddressTestnet,
                            fOTCValidator_Hash: fOTCValidator_Hash,
                            fOTC_NFT_PRE_Script: fOTC_NFT_PRE_Script,
                            _isDeployed: false
                        });
                        return [
                            4,
                            _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .ProtocolApi.createApi */ .O.createApi(protocol)
                        ];
                    case 3:
                        protocol_ = _state.sent();
                        //--------------------------------------
                        return [
                            4,
                            _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .ProtocolApi.createHookApi */ .O.createHookApi(_lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_2__/* .ProtocolEntity */ .A, protocol.getNet_Address(), protocol_.fProtocolPolicyID_CS)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            4,
                            _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .ProtocolApi.createHookApi */ .O.createHookApi(_lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_2__/* .OTCEntity */ .S, protocol.getOTC_Net_Address(), protocol_.fOTCPolicyID_CS)
                        ];
                    case 5:
                        _state.sent();
                        //--------------------------------------
                        // Update the context
                        setAppState(function(prev) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prev), {
                                protocol: protocol_
                            });
                        });
                        //--------------------------------------
                        (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .pushSucessNotification */ .o4X)("".concat(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t), "Protocol created successfully", false);
                        //--------------------------------------
                        appStore.setIsConfirmedTask(true);
                        //--------------------------------------
                        return [
                            2,
                            protocol_._DB_id
                        ];
                    case 6:
                        error = _state.sent();
                        console.log("[".concat(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t, "] - handleBtnProtocolCreate - Error: ").concat(error));
                        (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .pushWarningNotification */ .MQB)("".concat(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t), "Error creating Protocol: ".concat(error));
                        appStore.setIsFaildedTask(true);
                        return [
                            2,
                            undefined
                        ];
                    case 7:
                        appStore.setIsProcessingTask(false);
                        appStore.setProcessingTaskMessage("");
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCreateProtocol() {
            return _ref.apply(this, arguments);
        };
    }();
    //-------------------------
    var handleDeleteProtocol = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (appStore.isProcessingTx === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                            return [
                                2
                            ];
                        }
                        if (appStore.isProcessingTask === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TASK */ .DC.PROCESSING_TASK);
                            return [
                                2
                            ];
                        }
                        if (!confirm("Are you sure you want to delete the protocol?")) return [
                            3,
                            6
                        ];
                        //--------------------------------------
                        appStore.setProcessingTaskName(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .TaskEnums.DELETE_PROTOCOL */ .Xz.DELETE_PROTOCOL);
                        appStore.setIsProcessingTask(true);
                        appStore.setIsConfirmedTask(false);
                        appStore.setIsFaildedTask(false);
                        //--------------------------------------
                        appStore.setProcessingTaskMessage("Deleting Protocol...");
                        openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TASK */ .DC.PROCESSING_TASK);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .ProtocolApi.deleteByIdApi_ */ .O.deleteByIdApi_(appState.protocol._DB_id)
                        ];
                    case 2:
                        _state.sent();
                        //--------------------------------------
                        (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .pushSucessNotification */ .o4X)("".concat(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t), "Protocol deleted successfully", false);
                        //--------------------------------------
                        return [
                            4,
                            fetchProtocol()
                        ];
                    case 3:
                        _state.sent();
                        //--------------------------------------
                        appStore.setIsConfirmedTask(true);
                        //--------------------------------------
                        return [
                            2
                        ];
                    case 4:
                        error = _state.sent();
                        console.log("[".concat(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t, "] - handleDeleteProtocol - Error: ").concat(error));
                        (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .pushWarningNotification */ .MQB)("".concat(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t), "Error deleting Protocol: ".concat(error));
                        appStore.setIsFaildedTask(true);
                        return [
                            2,
                            undefined
                        ];
                    case 5:
                        appStore.setIsProcessingTask(false);
                        appStore.setProcessingTaskMessage("");
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteProtocol() {
            return _ref.apply(this, arguments);
        };
    }();
    //-------------------------
    var handleAddTokens = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var ref, lucid, emulatorDB, walletTxParams, walletUTxOs, uTxO, valueTokens1, valueTokenMAYZ, valueTokens, assets, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (appStore.isProcessingTx === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                            return [
                                2
                            ];
                        }
                        if (appStore.isProcessingTask === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TASK */ .DC.PROCESSING_TASK);
                            return [
                                2
                            ];
                        }
                        if (!confirm("Are you sure you want to Add Tokens?")) return [
                            3,
                            8
                        ];
                        //--------------------------------------
                        appStore.setProcessingTaskName(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .TaskEnums.ADD_TEST_TOKENS */ .Xz.ADD_TEST_TOKENS);
                        appStore.setIsProcessingTask(true);
                        appStore.setIsConfirmedTask(false);
                        appStore.setIsFaildedTask(false);
                        //--------------------------------------
                        appStore.setProcessingTaskMessage("Adding Tokens...");
                        openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TASK */ .DC.PROCESSING_TASK);
                        return [
                            4,
                            smart_db__WEBPACK_IMPORTED_MODULE_8__/* .LucidToolsFrontEnd.prepareLucidFrontEndForTx */ .fmW.prepareLucidFrontEndForTx(walletStore)
                        ];
                    case 1:
                        ref = _state.sent(), lucid = ref.lucid, emulatorDB = ref.emulatorDB, walletTxParams = ref.walletTxParams;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            6,
                            7,
                            8
                        ]);
                        walletUTxOs = walletTxParams.utxos;
                        if (walletUTxOs.length === 0) {
                            throw "You need at least one utxo to add tokens";
                        }
                        uTxO = walletUTxOs[0];
                        valueTokens1 = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .TEST_TOKEN_POLICY_CS */ .Ex + (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .strToHex */ .pzN)(_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .TEST_TOKEN_TN_Str */ .DC), BigInt(100));
                        valueTokenMAYZ = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, appState.protocol.pd_mayz_policy_id + appState.protocol.pd_mayz_tn, BigInt(100));
                        valueTokens = (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .addAssets */ .q$g)(valueTokens1, valueTokenMAYZ);
                        //--------------------------------------
                        console.log("[User] - Get Tokens Tx - valueTokens: ".concat((0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .showData */ .dMk)(valueTokens)));
                        assets = lucid.config().provider.ledger[uTxO.txHash + uTxO.outputIndex].utxo.assets;
                        lucid.config().provider.ledger[uTxO.txHash + uTxO.outputIndex].utxo.assets = (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .addAssets */ .q$g)(assets, valueTokens);
                        if (!(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .isEmulator */ .Itp && emulatorDB !== undefined)) return [
                            3,
                            4
                        ];
                        // normalmente esto se hace en el submit, pero esta tx es mock y no hay submit
                        return [
                            4,
                            smart_db__WEBPACK_IMPORTED_MODULE_8__/* .LucidToolsFrontEnd.syncEmulatorAfterTx */ .fmW.syncEmulatorAfterTx(lucid, emulatorDB)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        //--------------------------------------
                        return [
                            4,
                            walletStore.loadWalletData()
                        ];
                    case 5:
                        _state.sent();
                        //--------------------------------------
                        (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .pushSucessNotification */ .o4X)("".concat(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t), "Added tokens successfully", false);
                        //--------------------------------------
                        appStore.setIsConfirmedTask(true);
                        //--------------------------------------
                        return [
                            2,
                            true
                        ];
                    case 6:
                        error = _state.sent();
                        console.log("[".concat(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t, "] - handleAddTokens - Error: ").concat(error));
                        (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .pushWarningNotification */ .MQB)("".concat(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t), "Error Adding Tokens: ".concat(error));
                        appStore.setIsFaildedTask(true);
                        return [
                            2,
                            undefined
                        ];
                    case 7:
                        appStore.setIsProcessingTask(false);
                        appStore.setProcessingTaskMessage("");
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddTokens() {
            return _ref.apply(this, arguments);
        };
    }();
    //-------------------------
    var handleDeployProtocol = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var pd_mayz_deposit_requirementNumber, fetchParams, txApiCall, handleBtnTx;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (appStore.isProcessingTx === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                            return [
                                2
                            ];
                        }
                        if (appStore.isProcessingTask === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TASK */ .DC.PROCESSING_TASK);
                            return [
                                2
                            ];
                        }
                        if (pdAdmins.length === 0) {
                            setError("Please enter a valid Admin Payment Key Hashes.");
                            return [
                                2
                            ];
                        }
                        if ((0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .isNullOrBlank */ .Xy7)(pdTokenAdminPolicy_CS)) {
                            setError("Please enter a valid Admin Token Currency Symbol.");
                        }
                        if (!pd_mayz_deposit_requirement) {
                            setError("Please enter a value.");
                            return [
                                2
                            ];
                        }
                        pd_mayz_deposit_requirementNumber = Number(pd_mayz_deposit_requirement);
                        if (isNaN(pd_mayz_deposit_requirementNumber)) {
                            setError("Please enter a valid number.");
                            return [
                                2
                            ];
                        }
                        if (pd_mayz_deposit_requirementNumber < 0) {
                            setError("Please enter a positive number.");
                            return [
                                2
                            ];
                        }
                        fetchParams = function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                                var ref, lucid, emulatorDB, walletTxParams, txParams;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                smart_db__WEBPACK_IMPORTED_MODULE_8__/* .LucidToolsFrontEnd.prepareLucidFrontEndForTx */ .fmW.prepareLucidFrontEndForTx(walletStore)
                                            ];
                                        case 1:
                                            ref = _state.sent(), lucid = ref.lucid, emulatorDB = ref.emulatorDB, walletTxParams = ref.walletTxParams;
                                            txParams = {
                                                protocol_id: appState.protocol._DB_id,
                                                pd_admins: pdAdmins !== undefined && pdAdmins !== "" ? pdAdmins.split(",").map(function(admin) {
                                                    return admin.trim();
                                                }) : [],
                                                pd_token_admin_policy_id: pdTokenAdminPolicy_CS,
                                                pd_mayz_policy_id: _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .MAYZ_CS */ .n8,
                                                pd_mayz_tn: (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .strToHex */ .pzN)(_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .MAYZ_TN_Str */ .Oi),
                                                pd_mayz_deposit_requirement: BigInt(pd_mayz_deposit_requirement)
                                            };
                                            return [
                                                2,
                                                {
                                                    lucid: lucid,
                                                    emulatorDB: emulatorDB,
                                                    walletTxParams: walletTxParams,
                                                    txParams: txParams
                                                }
                                            ];
                                    }
                                });
                            });
                            return function fetchParams() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        //--------------------------------------
                        openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                        txApiCall = _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .ProtocolApi.callGenericTxApi.bind */ .O.callGenericTxApi.bind(_lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .ProtocolApi */ .O);
                        handleBtnTx = smart_db__WEBPACK_IMPORTED_MODULE_8__/* .BaseSmartDBFrontEndBtnHandlers.handleBtnDoTransaction_V2_NoErrorControl.bind */ .crd.handleBtnDoTransaction_V2_NoErrorControl.bind(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .BaseSmartDBFrontEndBtnHandlers */ .crd);
                        //--------------------------------------
                        return [
                            4,
                            handleBtnDoTransaction_WithErrorControl(_lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_2__/* .ProtocolEntity */ .A, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .TxEnums.PROTOCOL_DEPLOY */ .Rc.PROTOCOL_DEPLOY, "Deploying Protocol...", "deploy-tx", fetchParams, txApiCall, handleBtnTx)
                        ];
                    case 1:
                        _state.sent();
                        //--------------------------------------
                        return [
                            4,
                            fetchProtocol()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeployProtocol() {
            return _ref.apply(this, arguments);
        };
    }();
    //-------------------------
    var handleUpdateProtocol = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var pd_mayz_deposit_requirementNumber, fetchParams, txApiCall, handleBtnTx;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (appStore.isProcessingTx === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                            return [
                                2
                            ];
                        }
                        if (appStore.isProcessingTask === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TASK */ .DC.PROCESSING_TASK);
                            return [
                                2
                            ];
                        }
                        if (pdAdmins.length === 0) {
                            setError("Please enter a valid Admin Payment Key Hashes.");
                            return [
                                2
                            ];
                        }
                        if ((0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .isNullOrBlank */ .Xy7)(pdTokenAdminPolicy_CS)) {
                            setError("Please enter a valid Admin Token Currency Symbol.");
                        }
                        if (!pd_mayz_deposit_requirement) {
                            setError("Please enter a value.");
                            return [
                                2
                            ];
                        }
                        pd_mayz_deposit_requirementNumber = Number(pd_mayz_deposit_requirement);
                        if (isNaN(pd_mayz_deposit_requirementNumber)) {
                            setError("Please enter a valid number.");
                            return [
                                2
                            ];
                        }
                        if (pd_mayz_deposit_requirementNumber < 0) {
                            setError("Please enter a positive number.");
                            return [
                                2
                            ];
                        }
                        fetchParams = function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                                var ref, lucid, emulatorDB, walletTxParams, txParams;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                smart_db__WEBPACK_IMPORTED_MODULE_8__/* .LucidToolsFrontEnd.prepareLucidFrontEndForTx */ .fmW.prepareLucidFrontEndForTx(walletStore)
                                            ];
                                        case 1:
                                            ref = _state.sent(), lucid = ref.lucid, emulatorDB = ref.emulatorDB, walletTxParams = ref.walletTxParams;
                                            txParams = {
                                                protocol_id: appState.protocol._DB_id,
                                                pd_admins: pdAdmins !== undefined && pdAdmins !== "" ? pdAdmins.split(",").map(function(admin) {
                                                    return admin.trim();
                                                }) : [],
                                                pd_token_admin_policy_id: pdTokenAdminPolicy_CS,
                                                pd_mayz_policy_id: _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .MAYZ_CS */ .n8,
                                                pd_mayz_tn: (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .strToHex */ .pzN)(_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .MAYZ_TN_Str */ .Oi),
                                                pd_mayz_deposit_requirement: BigInt(pd_mayz_deposit_requirement)
                                            };
                                            return [
                                                2,
                                                {
                                                    lucid: lucid,
                                                    emulatorDB: emulatorDB,
                                                    walletTxParams: walletTxParams,
                                                    txParams: txParams
                                                }
                                            ];
                                    }
                                });
                            });
                            return function fetchParams() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        //--------------------------------------
                        openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                        txApiCall = _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .ProtocolApi.callGenericTxApi.bind */ .O.callGenericTxApi.bind(_lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .ProtocolApi */ .O);
                        handleBtnTx = smart_db__WEBPACK_IMPORTED_MODULE_8__/* .BaseSmartDBFrontEndBtnHandlers.handleBtnDoTransaction_V2_NoErrorControl.bind */ .crd.handleBtnDoTransaction_V2_NoErrorControl.bind(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .BaseSmartDBFrontEndBtnHandlers */ .crd);
                        //--------------------------------------
                        return [
                            4,
                            handleBtnDoTransaction_WithErrorControl(_lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_2__/* .ProtocolEntity */ .A, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_5__/* .TxEnums.PROTOCOL_UPDATE */ .Rc.PROTOCOL_UPDATE, "Updating Protocol...", "update-tx", fetchParams, txApiCall, handleBtnTx)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        //--------------------------------------
        });
        return function handleUpdateProtocol() {
            return _ref.apply(this, arguments);
        };
    }();
    //--------------------------------------
    var handleSyncProtocol = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (appStore.isProcessingTx === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX);
                            return [
                                2
                            ];
                        }
                        if (appStore.isProcessingTask === true) {
                            openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TASK */ .DC.PROCESSING_TASK);
                            return [
                                2
                            ];
                        }
                        if (!confirm("Are you sure you want to sync the protocol?")) return [
                            3,
                            7
                        ];
                        //--------------------------------------
                        appStore.setProcessingTaskName(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .TaskEnums.SYNC_PROTOCOL */ .Xz.SYNC_PROTOCOL);
                        appStore.setIsProcessingTask(true);
                        appStore.setIsConfirmedTask(false);
                        appStore.setIsFaildedTask(false);
                        //--------------------------------------
                        appStore.setProcessingTaskMessage("Syncing Protocol...");
                        openModal(_utils_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .ModalsEnums.PROCESSING_TASK */ .DC.PROCESSING_TASK);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            6,
                            7
                        ]);
                        //--------------------------------------
                        return [
                            4,
                            _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .ProtocolApi.syncWithAddressApi_ */ .O.syncWithAddressApi_(appState.protocol.getNet_Address(), appState.protocol.getNET_id_CS(), true)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_3__/* .ProtocolApi.syncWithAddressApi_ */ .O.syncWithAddressApi_(appState.protocol.getOTC_Net_Address(), appState.protocol.getOTC_NET_id_CS(), true)
                        ];
                    case 3:
                        _state.sent();
                        //--------------------------------------
                        return [
                            4,
                            fetchProtocol()
                        ];
                    case 4:
                        _state.sent();
                        //--------------------------------------
                        (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .pushSucessNotification */ .o4X)("".concat(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t), "Protocol synced successfully", false);
                        //--------------------------------------
                        appStore.setIsConfirmedTask(true);
                        //--------------------------------------
                        return [
                            2,
                            true
                        ];
                    case 5:
                        error = _state.sent();
                        console.log("[".concat(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t, "] - handleSyncProtocol - Error: ").concat(error));
                        (0,smart_db__WEBPACK_IMPORTED_MODULE_8__/* .pushWarningNotification */ .MQB)("".concat(smart_db__WEBPACK_IMPORTED_MODULE_8__/* .PROYECT_NAME */ .n6t), "Error syncing Protocol: ".concat(error));
                        appStore.setIsFaildedTask(true);
                        return [
                            2,
                            undefined
                        ];
                    case 6:
                        appStore.setIsProcessingTask(false);
                        appStore.setProcessingTaskMessage("");
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSyncProtocol() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        appState: appState,
        appStore: appStore,
        pdAdmins: pdAdmins,
        setPdAdmins: setPdAdmins,
        pdTokenAdminPolicy_CS: pdTokenAdminPolicy_CS,
        setPdTokenAdminPolicy_CS: setPdTokenAdminPolicy_CS,
        pd_mayz_deposit_requirement: pd_mayz_deposit_requirement,
        set_pd_mayz_deposit_requirement: set_pd_mayz_deposit_requirement,
        error: error,
        handleCreateProtocol: handleCreateProtocol,
        handleDeployProtocol: handleDeployProtocol,
        handleSyncProtocol: handleSyncProtocol,
        handleAddTokens: handleAddTokens,
        handleDeleteProtocol: handleDeleteProtocol,
        handleUpdateProtocol: handleUpdateProtocol
    };
};

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 97468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useHome; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contexts_AppState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37970);
/* harmony import */ var _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1911);
/* harmony import */ var _lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3403);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75971);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_2__, _lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_3__, smart_db__WEBPACK_IMPORTED_MODULE_4__]);
([_lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_2__, _lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_3__, smart_db__WEBPACK_IMPORTED_MODULE_4__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);










// ---------------------- Fetch Helpers ----------------------------
var fetchWalletTokenDetails = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(walletStore) {
        var assets, filtered, details;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (walletStore.isWalletDataLoaded === false || walletStore.getUTxOsAtWallet().length === 0) return [
                        2,
                        undefined
                    ];
                    assets = (0,smart_db__WEBPACK_IMPORTED_MODULE_4__/* .getAssetOfUTxOs */ .V9b)(walletStore.getUTxOsAtWallet());
                    filtered = Object.fromEntries(Object.entries(assets).filter(function(param) {
                        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), unit = _param[0];
                        if (unit.length < 56) return false; // too short to have policy + asset
                        var policyId = unit.slice(0, 56);
                        var assetName = unit.slice(56);
                        return assetName.length > 0;
                    }));
                    return [
                        4,
                        smart_db__WEBPACK_IMPORTED_MODULE_4__/* .TokenMetadataFrontEndApiCalls.getAssetsWithDetailsApi */ .Gx9.getAssetsWithDetailsApi(filtered)
                    ];
                case 1:
                    details = _state.sent();
                    return [
                        2,
                        details.filter(function(item) {
                            return !(0,smart_db__WEBPACK_IMPORTED_MODULE_4__/* .isTokenADA */ .Gre)(item.CS, item.TN_Hex);
                        })
                    ];
            }
        });
    });
    return function fetchWalletTokenDetails(walletStore) {
        return _ref.apply(this, arguments);
    };
}();
var fetchOtcTokensWithMetadata = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var entities, tokens, metadataList;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_2__/* .OTCApi.getAllApi_ */ .N.getAllApi_({
                            fieldsForSelect: {},
                            loadRelations: {
                                smartUTxO_id: true
                            }
                        })
                    ];
                case 1:
                    entities = _state.sent();
                    if (entities.length === 0) return [
                        2,
                        []
                    ];
                    tokens = entities.map(function(param) {
                        var od_token_policy_id = param.od_token_policy_id, od_token_tn = param.od_token_tn;
                        return {
                            CS: od_token_policy_id,
                            TN_Hex: od_token_tn
                        };
                    });
                    return [
                        4,
                        smart_db__WEBPACK_IMPORTED_MODULE_4__/* .TokenMetadataFrontEndApiCalls.get_Tokens_MetadataApi */ .Gx9.get_Tokens_MetadataApi(tokens)
                    ];
                case 2:
                    metadataList = _state.sent();
                    return [
                        2,
                        entities.reduce(function(acc, entity) {
                            var metadata = metadataList.find(function(m) {
                                return m.CS === entity.od_token_policy_id && m.TN_Hex === entity.od_token_tn;
                            });
                            if (metadata) {
                                acc.push({
                                    entity: entity,
                                    metadata: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, metadata), {
                                        amount: BigInt(entity.od_token_amount)
                                    })
                                });
                            }
                            return acc;
                        }, [])
                    ];
            }
        });
    });
    return function fetchOtcTokensWithMetadata() {
        return _ref.apply(this, arguments);
    };
}();
// ------------------------- Hook ----------------------------------
var useHome = function() {
    var walletStore = (0,smart_db__WEBPACK_IMPORTED_MODULE_4__/* .useWalletStore */ .X$B)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_contexts_AppState__WEBPACK_IMPORTED_MODULE_1__/* .AppStateContext */ .z), appState = ref.appState, setAppState = ref.setAppState;
    var ref1 = (0,smart_db__WEBPACK_IMPORTED_MODULE_4__/* .useDetails */ .stq)({
        nameDetails: "Balance",
        loadDetails: function() {
            return fetchWalletTokenDetails(walletStore);
        },
        dependencies: [
            walletStore.isWalletDataLoaded
        ]
    }), isLoadingDetails = ref1.isLoadingDetails, isLoadedDetails = ref1.isLoadedDetails, walletTokens = ref1.current;
    var ref2 = (0,smart_db__WEBPACK_IMPORTED_MODULE_4__/* .useList */ .smg)({
        nameList: _lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_3__/* .OTCEntity.className */ .S.className(),
        loadList: fetchOtcTokensWithMetadata
    }), isLoadingList = ref2.isLoadingList, isLoadedList = ref2.isLoadedList, listOfOtcEntityWithTokens = ref2.list, refreshList = ref2.refreshList;
    var handleBtnSync = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            var e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!appState.protocol) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_2__/* .OTCApi.syncWithAddressApi */ .N.syncWithAddressApi(_lib_SmartDB_Entities__WEBPACK_IMPORTED_MODULE_3__/* .OTCEntity */ .S, appState.protocol.getOTC_Net_Address(), appState.protocol.getOTC_NET_id_CS(), true)
                        ];
                    case 2:
                        _state.sent();
                        refreshList();
                        (0,smart_db__WEBPACK_IMPORTED_MODULE_4__/* .pushSucessNotification */ .o4X)(smart_db__WEBPACK_IMPORTED_MODULE_4__/* .PROYECT_NAME */ .n6t, "Synchronization complete!", false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.error(e);
                        (0,smart_db__WEBPACK_IMPORTED_MODULE_4__/* .pushWarningNotification */ .MQB)(smart_db__WEBPACK_IMPORTED_MODULE_4__/* .PROYECT_NAME */ .n6t, "Synchronization Error: " + e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleBtnSync() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        appState: appState,
        sidebarState: appState.sidebarState,
        isWalletConnected: walletStore.isConnected,
        walletTokens: walletTokens,
        listOfOtcEntityWithTokens: listOfOtcEntityWithTokens
    };
};

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 36906:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Sidebar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Sidebar_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2606);
/* harmony import */ var _Sidebar_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Sidebar_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _SidebarContent_SidebarContent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92374);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_SidebarContent_SidebarContent__WEBPACK_IMPORTED_MODULE_1__]);
_SidebarContent_SidebarContent__WEBPACK_IMPORTED_MODULE_1__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
// Home.tsx



function Sidebar() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("aside", {
        className: (_Sidebar_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sideBarArea),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Sidebar_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sideBarBox),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "margin: 0px;",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Sidebar_module_scss__WEBPACK_IMPORTED_MODULE_2___default().simplebarOffset),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SidebarContent_SidebarContent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Sidebar_module_scss__WEBPACK_IMPORTED_MODULE_2___default().simplebarPlaceholder)
                        })
                    ]
                })
            })
        })
    });
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 92374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SidebarContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _useSidebarContent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45319);
/* harmony import */ var _SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16539);
/* harmony import */ var _SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2__);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_useSidebarContent__WEBPACK_IMPORTED_MODULE_1__]);
_useSidebarContent__WEBPACK_IMPORTED_MODULE_1__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];



function SidebarContent() {
    var ref = (0,_useSidebarContent__WEBPACK_IMPORTED_MODULE_1__/* .useSidebarContent */ .m)(), sidebarState = ref.sidebarState, setSideBarState = ref.setSideBarState, isWalletConnected = ref.isWalletConnected;
    var svgIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 18",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#000000",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "SVGRepo_bgCarrier",
                strokeWidth: "0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "SVGRepo_tracerCarrier",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "SVGRepo_iconCarrier",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#e6e9ec",
                    fillRule: "evenodd",
                    d: "M306.85084,260.853513 C306.94215,260.763222 307,260.638581 307,260.500923 L307,246.499077 C307,246.223683 306.776142,246 306.5,246 C306.231934,246 306,246.223444 306,246.499077 L306,260 L292.499077,260 C292.223683,260 292,260.223858 292,260.5 C292,260.768066 292.223444,261 292.499077,261 L306.500923,261 C306.638467,261 306.763112,260.94416 306.853432,260.853856 Z M304.85084,258.853513 C304.94215,258.763222 305,258.638581 305,258.500923 L305,244.499077 C305,244.223683 304.776142,244 304.5,244 C304.231934,244 304,244.223444 304,244.499077 L304,258 L290.499077,258 C290.223683,258 290,258.223858 290,258.5 C290,258.768066 290.223444,259 290.499077,259 L304.500923,259 C304.638467,259 304.763112,258.94416 304.853432,258.853856 Z M289,244.006845 C289,243.45078 289.449949,243 290.006845,243 L301.993155,243 C302.54922,243 303,243.449949 303,244.006845 L303,255.993155 C303,256.54922 302.550051,257 301.993155,257 L290.006845,257 C289.45078,257 289,256.550051 289,255.993155 L289,244.006845 Z",
                    transform: "translate(-289 -243)"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().barContent),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
            className: (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().navSection),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sectionTitle),
                    children: " Over The Counter "
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sectionItem),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        onClick: function() {
                            return setSideBarState("Protocol Area");
                        },
                        disabled: !isWalletConnected,
                        className: "".concat((_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sidebarItem), " ").concat(sidebarState == "Protocol Area" && (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().activeLink)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sidebarIcon),
                                children: svgIcon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "width: 100% !important;",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sidebarText),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Protocol Area "
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sectionItem),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        onClick: function() {
                            return setSideBarState("Claim");
                        },
                        disabled: !isWalletConnected,
                        className: "".concat((_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sidebarItem), " ").concat(sidebarState == "Claim" && (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().activeLink)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sidebarIcon),
                                children: svgIcon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "width: 100% !important;",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sidebarText),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Claim "
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sectionItem),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        onClick: function() {
                            return setSideBarState("My Area");
                        },
                        disabled: !isWalletConnected,
                        className: "".concat((_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sidebarItem), " ").concat(sidebarState == "My Area" && (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().activeLink)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sidebarIcon),
                                children: svgIcon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "width: 100% !important;",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_SidebarContent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sidebarText),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "My Area "
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 45319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useSidebarContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _contexts_AppState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37970);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75971);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_2__]);
smart_db__WEBPACK_IMPORTED_MODULE_2__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];





var useSidebarContent = function() {
    var setSideBarState = //   //----------------------------------------------------------------------------
    function setSideBarState(newSideBarState) {
        setAppState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, appState), {
            sidebarState: newSideBarState
        }));
    };
    var walletStore = (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .useWalletStore */ .X$B)();
    //   //----------------------------------------------------------------------------
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_AppState__WEBPACK_IMPORTED_MODULE_0__/* .AppStateContext */ .z), appState = ref.appState, setAppState = ref.setAppState;
    var sidebarState = appState.sidebarState;
    return {
        sidebarState: sidebarState,
        setSideBarState: setSideBarState,
        isWalletConnected: walletStore.isConnected
    };
};

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 3403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* reexport safe */ _Protocol_Entity__WEBPACK_IMPORTED_MODULE_1__.A; },
/* harmony export */   "S": function() { return /* reexport safe */ _OTC_Entity__WEBPACK_IMPORTED_MODULE_0__.S; }
/* harmony export */ });
/* harmony import */ var _OTC_Entity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59754);
/* harmony import */ var _Protocol_Entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(193);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_OTC_Entity__WEBPACK_IMPORTED_MODULE_0__, _Protocol_Entity__WEBPACK_IMPORTED_MODULE_1__]);
([_OTC_Entity__WEBPACK_IMPORTED_MODULE_0__, _Protocol_Entity__WEBPACK_IMPORTED_MODULE_1__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);



__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 85641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ metadata; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_document__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56859);
"use client";


var metadata = {
    title: "MAYZ - OTC",
    description: "OTC service of MAYZ protocol",
    applicationName: "MAYZ - OTC",
    themeColor: "#ffffff"
};
function Document() {
    return /*#__PURE__*/ _jsxs(Html, {
        lang: "en",
        children: [
            /*#__PURE__*/ _jsxs(Head, {
                children: [
                    /*#__PURE__*/ _jsx("meta", {
                        name: "description",
                        content: metadata.description
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "application-name",
                        content: metadata.applicationName
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "theme-color",
                        content: metadata.themeColor
                    }),
                    /*#__PURE__*/ _jsx("link", {
                        rel: "icon",
                        type: "image/ico",
                        href: "icon.ico"
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        charSet: "UTF-8"
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("body", {
                children: [
                    /*#__PURE__*/ _jsx(Main, {}),
                    /*#__PURE__*/ _jsx(NextScript, {})
                ]
            })
        ]
    });
}


/***/ }),

/***/ 30441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86719);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_public_Home_Home__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40297);
/* harmony import */ var _components_public_Sidebar_Sidebar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36906);
/* harmony import */ var _document__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85641);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_components_public_Home_Home__WEBPACK_IMPORTED_MODULE_1__, _components_public_Sidebar_Sidebar__WEBPACK_IMPORTED_MODULE_2__]);
([_components_public_Home_Home__WEBPACK_IMPORTED_MODULE_1__, _components_public_Sidebar_Sidebar__WEBPACK_IMPORTED_MODULE_2__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);

// Importing the `NextPage` type from Next.js to define the type of this component as a page in the application.

// Importing SCSS module for styling. The styles defined here can be applied to elements in this file.



// Importing the `Home` component from its path. This component will render the main content for the homepage.
var HomePage = function() {
    // Defining the `HomePage` functional component and typing it as a `NextPage`.
    // This indicates it's part of the Next.js routing system.
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    " ",
                    _document__WEBPACK_IMPORTED_MODULE_3__/* .metadata.applicationName */ .P.applicationName,
                    " "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().pageWrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().topbar)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_public_Sidebar_Sidebar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_public_Home_Home__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HomePage); // Exporting the `HomePage` component as the default export for this file.
 // This allows Next.js to recognize it as the route for the homepage ("/").

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 55208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ tokenMetadataToOtcCard; }
/* harmony export */ });
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75971);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_0__]);
smart_db__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];

function tokenMetadataToOtcCard(tokens) {
    return {
        image: (0,smart_db__WEBPACK_IMPORTED_MODULE_0__/* .getUrlForImage */ ._rQ)(tokens.token.image),
        photoAlt: (0,smart_db__WEBPACK_IMPORTED_MODULE_0__/* .hexToStr */ .NdO)(tokens.token.TN_Hex),
        tokenName: (0,smart_db__WEBPACK_IMPORTED_MODULE_0__/* .hexToStr */ .NdO)(tokens.token.TN_Hex),
        tokenAmount: tokens.token.amount,
        btnMod: tokens.btnHandler
    };
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 93589:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BlueButton":"BlueButton_BlueButton__7aWEl"};

/***/ }),

/***/ 29870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btnConnectWallet":"BtnConnectWallet_btnConnectWallet__dOho4"};

/***/ }),

/***/ 97565:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"Otc_separator__MaPz_","OtcContainer":"Otc_OtcContainer__8a1Dv"};

/***/ }),

/***/ 38132:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"OtcCard_separator__pbL4v","otcBox":"OtcCard_otcBox__QFIQD","otcDescription":"OtcCard_otcDescription__cUK51","otcTokenName":"OtcCard_otcTokenName__MCglo","otcTokenPhoto":"OtcCard_otcTokenPhoto__u01MU"};

/***/ }),

/***/ 3714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"TokenCard_separator__ExJ00","tokenCardContainer":"TokenCard_tokenCardContainer__YcnlS","tokenName":"TokenCard_tokenName__4W6lB","tokenAmount":"TokenCard_tokenAmount__OMt7U","tokenPhoto":"TokenCard_tokenPhoto__NLBsW","tokenAmountForm":"TokenCard_tokenAmountForm__Ooj7W","tokenAmountCaption":"TokenCard_tokenAmountCaption__pL8BO","tokenAmountInput":"TokenCard_tokenAmountInput__22xOi","deployButton":"TokenCard_deployButton__LlNMy"};

/***/ }),

/***/ 84346:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"claim":"Claim_claim__Qqmz_"};

/***/ }),

/***/ 2302:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"SearchElement_searchContainer__ueyR9","searchBox":"SearchElement_searchBox__p_msL","searchArea":"SearchElement_searchArea__LYOF_"};

/***/ }),

/***/ 54143:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Home_mainContainer__UuQdC","mainSection":"Home_mainSection__mAFWP","card":"Home_card__rRLpP","protocolMessage":"Home_protocolMessage__0Elva","cardHeader":"Home_cardHeader__WJTGs","walletBtn":"Home_walletBtn__zbTUd","cardCaption":"Home_cardCaption__SZEcU"};

/***/ }),

/***/ 66110:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cancel":"MyArea_cancel__P4oxz","close":"MyArea_close__XvRVp"};

/***/ }),

/***/ 64206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"YourTokenSeccion_separator__kwTjm","yourTokenSeccionContainer":"YourTokenSeccion_yourTokenSeccionContainer__t0OG_","tokenGrid":"YourTokenSeccion_tokenGrid__DLZS2"};

/***/ }),

/***/ 36581:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"ProtocolArea_form__OEWAl","formGroup":"ProtocolArea_formGroup__BfDj_","errorMessage":"ProtocolArea_errorMessage__Dbo3t","btnAction":"ProtocolArea_btnAction__44wVM"};

/***/ }),

/***/ 2606:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sideBarArea":"Sidebar_sideBarArea__jyRBH","sideBarBox":"Sidebar_sideBarBox__sVkKf","simplebarPlaceholder":"Sidebar_simplebarPlaceholder__64dPN","simplebarOffset":"Sidebar_simplebarOffset__oqQ_n"};

/***/ }),

/***/ 16539:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"barContent":"SidebarContent_barContent__rL_pj","navSection":"SidebarContent_navSection__DtYi4","sectionTitle":"SidebarContent_sectionTitle__WnnOm","sidebarItem":"SidebarContent_sidebarItem__oaY96","activeLink":"SidebarContent_activeLink__3yV1L","sidebarIcon":"SidebarContent_sidebarIcon__mhw2I","sidebarText":"SidebarContent_sidebarText__WC0x_"};

/***/ }),

/***/ 86719:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"index_pageWrapper__xSU6O","topbar":"index_topbar__Lgb0B"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [18,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);